const home = state => state;

export default {
    home
};
